<template>
  <form id="schoolForm">
    <div class="mb-2">
      <label for="registryCode" class="form-label">{{ t('SCHOOL_CODE') }}</label>
      <InputText
          id="registryCode"
          class="w-100"
          v-model="schoolForm.registryCode"
          type="text"
          :title="t('ONLY_DIGITAL')"
          maxlength="8"
          required
          :invalid="codeState === false"
          @input="onRegistryCodeInput"
      />
      <small v-if="codeState === false" class="text-danger">{{ codeFeedback }}</small>
    </div>

    <div class="mb-2">
      <label for="businessName" class="form-label">{{ t('SCHOOL_NAME') }}</label>
      <InputText
          id="businessName"
          type="text"
          class="w-100"
          v-model="schoolForm.businessName"
          :title="t('MIN_5_CHARS')"
          required
          :invalid="businessNameState === false"
      />
      <small v-if="businessNameState === false" class="text-danger">{{ businessNameFeedback }}</small>
    </div>

    <div class="mb-2">
      <label for="schoolManagers" class="form-label">{{ t('SCHOOL_MANAGER') }}</label>
      <MultiSelect
          v-model="schoolForm.selectedManagers"
          :options="managerOptions"
          option-label="fullName"
          option-value="id"
          multiple
          input-id="schoolManagers"
          class="w-100"
          :placeholder="t('SELECT')"
          :showToggleAll="false"
      />
    </div>

    <div class="mb-2">
      <label for="modules" class="form-label">{{ t('MODULES') }}</label>
      <MultiSelect
          v-model="schoolForm.selectedModules"
          :options="moduleOptions"
          option-label="code"
          option-value="id"
          multiple
          input-id="modules"
          class="w-100"
          :placeholder="t('SELECT')"
          :showToggleAll="false"
      />
    </div>
  </form>
</template>
<script setup>
import {computed, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useToast} from "@/util/toastUtils";

defineExpose({
  submitForm,
});

const {t} = useI18n();
const toast = useToast();
const props = defineProps({managerOptions: Array, moduleOptions: Array});
const schoolForm = ref({
  registryCode: null,
  businessName: null,
  selectedManagers: [],
  selectedModules: []
});

const registryCodeRegex = /^\d{8}$/;
const emit = defineEmits(["submit-school"]);

const validateCode = (code) => {
  return registryCodeRegex.test(code);
};

const validateBusinessName = (name) => {
  return name.trim().length >= 5;
};

function isFormValid() {
  return validateCode(schoolForm.value.registryCode) && validateBusinessName(schoolForm.value.businessName);
}

function submitForm() {
  if (!isFormValid()) {
    toast.makeErrorToast(t("CHECK_INPUT"));
    return false;
  }

  emit("submit-school", schoolForm.value);
  return true;
}

const codeFeedback = computed(() => {
  return codeState.value ? "" : `${t("ONLY_DIGITAL")} ${t("MIN_8_CHARS")}`;
});

const businessNameFeedback = computed(() => {
  return businessNameState.value ? "" : t("MIN_5_CHARS");
});

const codeState = computed(() => {
  return schoolForm.value.registryCode === null ? null : validateCode(schoolForm.value.registryCode);
});

const businessNameState = computed(() => {
  return schoolForm.value.businessName === null ? null : validateBusinessName(schoolForm.value.businessName);
});

function onRegistryCodeInput(e) {
  schoolForm.value.registryCode = e.target.value.replaceAll(/\D/g, "");
}
</script>
